var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"logo-container",class:[("text-" + _vm.color), { horizontal: _vm.horizontal }],attrs:{"to":{ name: 'Home' }}},[_c('img',{attrs:{"src":_vm.logoUrl}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }